import { render, staticRenderFns } from "./table_head.vue?vue&type=template&id=d126aa9e&lang=pug"
import script from "./table_head.vue?vue&type=script&lang=js"
export * from "./table_head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports